import { useState, useMemo, useEffect } from "react"
import { useFormikContext, getIn, FieldArray, useField } from "formik";
import { KTSVG } from "../../../../../../../../_metronic/helpers";
import { cloneDeep } from "lodash";
import { IDOCLabelSite, initDOCLabelSiteValues } from "../core";

import { FormikTextInput, FormikTextField, FormikFileUpload  } from "../../../../../../../components/widgets";

import { IndexSelector } from "../../../../../../../components/layout";

import { DOCLabelItemDetailsTable } from "./DOCLabelItemDetailsTable";
import { useDOCLabelFormView } from "./DOCLabelFormContextProvider";
import { DOCLabelDownloadTemplateButton } from "./DOCLabelDownloadTemplateButton";
import { DOCLabelTemplateUploader } from "./DOCLabelTemplateUploader";


const DOCLabelSiteDetailsPanel = () => {

const { initValues } = useDOCLabelFormView();

const { appType, companyName, requestMode } = initValues;
const [ index, setIndex] = useState(0);
const { values, setFieldValue, setFieldTouched, validateField } = useFormikContext();

const { siteDetails } = useMemo(() => {
  if (! values) return { siteDetails: []};
  let siteDetails = getIn(values, 'siteDetails');        
  return { siteDetails };
}, [values]);

const [,meta,] = useField('totalLabelQuantity')

const { error: totalLabelError } = meta;


const {num_sites, total_labels, site_labels} = useMemo(() => {
  if (! (siteDetails)) {
    return { num_sites : 0, total_labels : 0, site_labels: 0};
  }

  let num_sites = siteDetails && siteDetails.length > 0 ? siteDetails.length : 0;

  if (! (['Label5','Label1b1','Label1b2','Label1b3'].includes(appType))) {
    return { num_sites, total_labels: 0, site_labels: 0};
  }

  let total_labels = 0;
  let site_labels = 0;
  
  siteDetails.forEach((_site:IDOCLabelSite, _idx: number)  => {
    if (! (_site.hasOwnProperty('itemDetails') && _site.itemDetails.length > 0)) return;
    _site.itemDetails.forEach(_item => {
      if (_item?.quantity && _item.quantity > 0) {
        total_labels += parseInt(`${_item.quantity}`);
        if (_idx === index) {
          site_labels += parseInt(`${_item.quantity}`);                                
        }
      }
    })
  });        

  return { num_sites, total_labels, site_labels};

}, [siteDetails, index, appType]);


useEffect(() => {
  setFieldValue('totalLabelQuantity',  total_labels);            
  setFieldTouched('totalLabelQuantity', true);
  setTimeout(() => {
    validateField('totalLabelQuantity');                
  }, 100)         
  // eslint-disable-next-line        
}, [total_labels]);

useEffect(() => {
  if (! (num_sites && index < num_sites)) {
    setIndex(0);            
  }        
}, [num_sites, index]);

return (
<FieldArray
  name="siteDetails"
  render={arrayHelpers => (
  <>
  { (['Label5','Label1b1','Label1b2','Label1b3'].includes(appType)) ? (
  <>
  { (! ['resubmit_site','edit_site'].includes(requestMode)) && 
  <>
  <div className='d-flex flex-row align-items-start justify-content-between gap-4'>
    <div className="fw-bold text-muted fs-6">
      SITE APPLICATION DETAILS
    </div>

    <div className="d-flex flex-column align-items-end fs-6 pe-2">
      <div>
        <label className="fw-bold fs-6 me-2">TOTAL LABEL QUANTITY :</label>
        <span className="fw-bold fs-6">{total_labels}</span>
      </div>
      { (totalLabelError && typeof totalLabelError === 'string') && (
      <div className='fv-plugins-message-container'>
        <div className='fv-help-block fs-7'>
          <span role='alert'>{totalLabelError}</span>
        </div>
      </div>
      )}
    </div>                
  </div>                        
  <div className="d-flex flex-row flex-stack mb-2">
    <div className="d-flex flex-column flex-md-row align-items-center gap-4">
      <DOCLabelTemplateUploader />
      <DOCLabelDownloadTemplateButton />
    </div>
    <div className="d-flex flex-row gap-2">
      <IndexSelector
        itemCount={num_sites}
        currentIndex={index}
        displayCount={5}
        onChangeIndex={setIndex}
      />
      { (! ['edit_app','edit_site'].includes(requestMode)) && 
      <>
      { (num_sites < 2) &&
      <div className="text-muted fs-7">Click to add more sites →</div>
      }
      { (num_sites < 50) &&
      <button
        type="button"
        className="siteBtn btn btn-light-success text-success btn-active-success px-2 py-1 lh-0"
        onClick={() => {
          if(! (num_sites < 50)) return;
          arrayHelpers.push({
            ...cloneDeep(initDOCLabelSiteValues),
            installerName: companyName
          });
          setIndex(num_sites);
        }}
        title="Click to Add Site"
        disabled={! (num_sites < 50)}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr017.svg' className='svg-icon m-0' />
      </button>
      }
      { (num_sites > 1) &&
      <button
        type="button"
        className="siteBtn btn btn-light-danger text-danger btn-active-danger px-2 py-1 lh-0"
        onClick={() => {
          arrayHelpers.remove(index);
          setIndex((index + 1 === num_sites ? index - 1 : index));
        }}
        title={`Click to delete site ${index + 1}`}
        disabled={! (num_sites > 1)}
      >
        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon m-0' />
      </button>
      }
      </>
      }
    </div>
  </div>            
  <div className='separator border-gray-200 my-2'></div>
  </>
  }            
  <div className="fw-bold text-muted fs-6">
    SITE DETAILS
  </div>
  </>            
  ) : (
  <div className="fw-bold text-muted fs-6">
    SITE DETAILS
  </div>
  )}                                
  <div className="row">    
    {(['Label5','Label1b1','Label1b2','Label1b3'].includes(appType)) ? (
    <FormikTextField size="12" label="Project Name/Location" name={`siteDetails.${index}.projectName`} required={true} rows={2}/>    
    ) : (
    <>
    <FormikTextField size="12" label="Project Name" name={`siteDetails.${index}.projectName`} required={true} rows={1}/>    
    <FormikTextField size="12" label="Project Location" name={`siteDetails.${index}.projectLocation`} required={true} rows={1} />
    </>
    )}    
  </div>
  <div className="row">
    <FormikTextInput size="12 col-md-4" label="Installer Company" name={`siteDetails.${index}.installerName`} required={! ['SiteInspect','TriggerTest','LabelInspect','Label1b1','Label1b2','Label1b3','Label5'].includes(appType)} />
    <FormikTextInput size="12 col-md-4" label="SCDF Building Plan No" name={`siteDetails.${index}.bpNumber`} pattern="^([A-Z]{3})\/([A-Z]{1})([0-9]{5})\/([0-9]{2})([\S]{1,2})?$" />
    {(['Label5','Label1b1','Label1b2','Label1b3'].includes(appType)) &&
    <FormikTextInput size="12 col-md-4" label="Client Ref No" name={`siteDetails.${index}.clientRefNo`} />
    }
  </div>
  <div className="row">
    <FormikTextInput size="8" label="Other Reference Number (DSTA Number)" name={`siteDetails.${index}.otherReference`}/>                
    { (['Label5','Label1b1','Label1b2','Label1b3'].includes(appType)) &&
    <div className="col-4 d-flex flex-column">
      <label className="fw-bold fs-7 mb-1">Site Label Count :</label>
      <div className="form-control form-control-sm form-control-outline fw-bold fs-7">{site_labels}</div>
    </div>
    }
  </div>

  {(['SiteInspect','LabelInspect','MandatoryDOC'].includes(appType)) &&
  <>
  <div className="row">
    <div className="col-12 fw-bold fs-6 mb-1">Supporting Documents :</div>
  </div>
  <div className="row">
    <FormikFileUpload size="12 col-md-4" label="Prototype Test Report" name={`siteDetails.${index}.prototypeTestReport`} acceptFiles="ApplicantFileFormats" />
    <FormikFileUpload size="12 col-md-4" label="Training Record" name={`siteDetails.${index}.trainingRecord`} acceptFiles="ApplicantFileFormats" />
    <FormikFileUpload size="12 col-md-4" label="Method of Statment" name={`siteDetails.${index}.methodOfStatement`} acceptFiles="ApplicantFileFormats" />
    <FormikFileUpload size="12 col-md-4" label="Product Construction DWG" name={`siteDetails.${index}.productConstructionDrawing`} acceptFiles="ApplicantFileFormats" />
    <FormikFileUpload size="12 col-md-4" label="Site Plan/Site DWG" name={`siteDetails.${index}.sitePlanDrawing`} acceptFiles="ApplicantFileFormats" />
    <FormikFileUpload size="12 col-md-4" label="Site Checklist" name={`siteDetails.${index}.siteChecklist`} acceptFiles="ApplicantFileFormats" />
    <FormikFileUpload size="12 col-md-4" label="Setsco ROI" name={`siteDetails.${index}.setscoROI`} acceptFiles="ApplicantFileFormats"  />
  </div>
  </>
  }
  { (['Label5','Label1b1','Label1b2','Label1b3'].includes(appType)) &&
  <>
  <div className='separator border-gray-200 my-0'></div>
  <DOCLabelItemDetailsTable siteIndex={index} />
  </>
  }
  </>
  )}
/>
)
}

export { DOCLabelSiteDetailsPanel }
